/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import get from 'lodash/get';
import debounce from 'lodash/debounce';

import {
  getOrganizerTasks,
  getOrganizerProjects,
  getOrganizerProjectsBasicDetails,
  searchOrganizerTasks,
  searchOrganizerProjects,
} from '@/api';

import { ORGANIZER_TASKS, ORGANIZER_PROJECTS, PROJECTS_SELECT } from '@/store/mutation-types';

const state = {
  organizer_tasks_loading: false,
  organizer_tasks: [],
  organizer_tasks_take: 20,
  organizer_tasks_skip: 0,
  organizer_tasks_exhausted: false,

  organizer_projects_loading: false,
  organizer_projects: [],
  organizer_projects_take: 20,
  organizer_projects_skip: 0,
  organizer_projects_exhausted: false,

  projects_select: null,
};

const getters = {
  tasksLoading(state) {
    return state.organizer_tasks_loading;
  },
  organizerTasks(state) {
    return state.organizer_tasks || [];
  },
  projectsLoading(state) {
    return state.organizer_projects_loading;
  },
  organizerProjects(state) {
    return state.organizer_projects || [];
  },
  projectsSelect(state) {
    return state.projects_select;
  },
};
const actions = {
  getOrganizerTasks({ commit, state }, params = {}) {
    if (state.organizer_tasks_loading || state.organizer_tasks_exhausted) return;
    commit('ORGANIZER_TASKS_LOADING', true);

    const userToken = this.getters['auth/userToken'];
    const { organizer_tasks_skip: skip, organizer_tasks_take: take } = state;
    getOrganizerTasks(userToken, { skip, take, ...params })
      .then(({ data }) => {
        const organizerTasks = get(data, '[1].data.details', []);
        commit(ORGANIZER_TASKS, organizerTasks);

        if (get(data, '[1].error.error_type') === 'NO_DATA') {
          commit('ORGANIZER_TASKS_EXHAUSTED');
        }

        commit('ORGANIZER_TASKS_LOADING', false);
      })
      .catch(() => {
        commit('ORGANIZER_TASKS_LOADING', false);
      });
  },
  projectReset({ commit }) {
    commit('ORGANIZER_PROJECTS_RESET');
  },
  getOrganizerProjects({ commit, state }) {
    if (state.organizer_projects_loading || state.organizer_projects_exhausted) return;
    commit('ORGANIZER_PROJECTS_LOADING', true);

    const userToken = this.getters['auth/userToken'];
    const { organizer_projects_skip: skip, organizer_projects_take: take } = state;
    getOrganizerProjects(userToken, { skip, take })
      .then(({ data }) => {
        const organizerProjects = get(data, '[1].data.details', []);
        commit(ORGANIZER_PROJECTS, organizerProjects);

        if (get(data, '[1].error.error_type') === 'NO_DATA') {
          commit('ORGANIZER_PROJECTS_EXHAUSTED');
        }

        commit('ORGANIZER_PROJECTS_LOADING', false);
      })
      .catch(() => {
        commit('ORGANIZER_PROJECTS_LOADING', false);
      });
  },
  getOrganizerProjectsBasicDetails({ commit }) {
    const userToken = this.getters['auth/userToken'];
    getOrganizerProjectsBasicDetails(userToken)
      .then(({ data }) => {
        const projectsSelect = get(data, '[1].data.details');
        commit(PROJECTS_SELECT, projectsSelect);
      });
  },
  searchOrganizerTasks: debounce(
    function _serachOrganizerTasks({ commit }, taskSearchValue) {
      const userToken = this.getters['auth/userToken'];
      this.dispatch('shared/setDataLoading', true);
      searchOrganizerTasks(userToken, taskSearchValue)
        .then(({ data }) => {
          commit('TASK_RESET');
          const organizerTasks = get(data, '[1].data.details');
          commit(ORGANIZER_TASKS, organizerTasks);
          this.dispatch('shared/setDataLoading', false);
        });
    }, 1500, { leading: false },
  ),
  searchOrganizerProjects: debounce(
    function _searchOrganizerProjects({ commit }, projectNameSearch) {
      const userToken = this.getters['auth/userToken'];
      searchOrganizerProjects(userToken, projectNameSearch)
        .then(({ data }) => {
          commit('ORGANIZER_PROJECTS_RESET');
          const organizerProjects = get(data, '[1].data.details');
          commit(ORGANIZER_PROJECTS, organizerProjects);
        });
    }, 1500, { leading: false },
  ),
  taskReset({ commit }) {
    commit('TASK_RESET');
  },
};

const mutations = {
  [ORGANIZER_TASKS](state, organizerTasks) {
    state.organizer_tasks = [...state.organizer_tasks, ...organizerTasks];
    state.organizer_tasks_skip += state.organizer_tasks_take;
  },
  [ORGANIZER_PROJECTS](state, organizerProjects) {
    state.organizer_projects = [...state.organizer_projects, ...organizerProjects];
    state.organizer_projects_skip += state.organizer_projects_take;
  },
  [PROJECTS_SELECT](state, projectsSelect) {
    state.projects_select = projectsSelect;
  },
  ORGANIZER_PROJECTS_LOADING(state, value) {
    state.organizer_projects_loading = value;
  },
  ORGANIZER_PROJECTS_EXHAUSTED(state) {
    state.organizer_projects_exhausted = true;
  },
  ORGANIZER_PROJECTS_RESET(state) {
    state.organizer_projects = [];
    state.organizer_projects_skip = 0;
    state.organizer_projects_exhausted = false;
  },
  ORGANIZER_TASKS_LOADING(state, value) {
    state.organizer_tasks_loading = value;
  },
  ORGANIZER_TASKS_EXHAUSTED(state) {
    state.organizer_tasks_exhausted = true;
  },
  TASK_RESET(state) {
    state.organizer_tasks = [];
    state.organizer_tasks_exhausted = false;
    state.organizer_tasks_skip = 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/organizer.js